import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "disabled", "trueValue", "style", "children", "value", "ref", "key", "title"];
import { createVNode as _$cv, className as _$cn, createUnknownComponentVNode as _$cc, createElementVNode as _$ce } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
import { Wave } from '../wave';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    disabled = _this$get.disabled,
    trueValue = _this$get.trueValue,
    style = _this$get.style,
    children = _this$get.children,
    value = _this$get.value,
    ref = _this$get.ref,
    key = _this$get.key,
    title = _this$get.title,
    rest = _objectWithoutPropertiesLoose(_this$get, _excluded);
  var isChecked = value === trueValue;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-radio"] = true, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-checked"] = isChecked, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);

  // let evClick;
  var events = ['ev-click', 'ev-change', 'ev-mouseenter', 'ev-mouseleave'].reduce(function (memo, name) {
    if (rest[name]) {
      if (name === 'ev-click' || name === 'ev-change') {
        // don't bind click to label, otherwise it will trigger click event twice
        // don't bind change to input, use click instead of, #448
        // evClick = rest[name];
      } else {
        memo[name] = rest[name];
      }
      delete rest[name];
    }
    return memo;
  }, {});
  return _$cv('label', _extends({}, events, {
    'className': _$cn(classNameObj),
    'style': style,
    'title': title,
    'tabindex': disabled ? "-1" : "0",
    'ev-keypress': this.onKeypress,
    'ev-click': this.fixClick
  }), [_$cc(Wave, {
    'disabled': disabled,
    'inset': '-2px',
    'children': _$ce(2, 'span', _$cv('input', _extends({}, getRestProps(this, rest), {
      'type': 'radio',
      'disabled': disabled,
      'value': trueValue,
      'tabindex': '-1',
      'ref': this.elementRef,
      'checked': isChecked,
      'ev-click': this.onClick
    })), 2, _$cn(k + "-radio-wrapper"))
  }), children ? _$ce(2, 'span', children, 0, _$cn(k + "-radio-text")) : undefined]);
}
;